import { operationsSlice } from './slice';

export * from './state';

const { reducer, actions } = operationsSlice;
export const { setSelectedRouteId, setSortByFilterValue } = actions;
export default reducer;
